if(!customElements.get('nost-tabs')) {
  customElements.define('nosto-tabs', class nostoTabs extends HTMLElement {
    constructor() {
      super();
      this.abortController = new AbortController()
      this.sliders = [];
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.tab-list a');
      this.activeTab = this.querySelector('.tab-list a.active').getAttribute('data-tab');
      this.allSelectors = Array.from(this.querySelectorAll('[data-tab]'));
      this.collectionQuery = this.querySelectorAll('.collection-tab');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick.bind(this), {
          signal: this.abortController.signal
        });
      })

      this.loadCollections();
    }

    onTabClick(evt) {
      evt.preventDefault();
      const tabRef = evt.target.dataset.tab;
      this.allSelectors.forEach((tab) => {
        if(tab.dataset.tab == tabRef) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      })
    }

    loadCollections() {
      this.collectionQuery.forEach((col, index) => {
        const collectionId = col.dataset.collectionId;
        const apiOptions = {
          products: {
            facets: ['*'],
            fields: ['url'],
            size: 12,
            from: 0,
            categoryId: collectionId
          }
        }

        nostojs(api => {
          api.search(apiOptions, {
            redirect: false
          }).then(response => {
            const products = response.products.hits.map(product => {
              return `
                <li><v3-product-card data-url="${product.url}" class="skeleton-item" data-hide-swatches="true"></v3-product-card></li>
              `
            });
            const sliderHTML = `
              <ul
                data-nosto="false"
                data-id="collection-tab--${collectionId}"
                data-title="">
                ${products.join('')}
              </ul>
            `

            col.innerHTML = sliderHTML;

            if(index == 0) {
              col.parentElement.classList.add('active');
              this.querySelector('.v2-nosto-category-recs-skeleton').remove();
            }

            this.initSlider(col.querySelector('ul'));
          })
        })
      })
    }

    initSlider(container) {
      const slider = new tns({
        autoWidth: false,
        items: 4,
        gutter: 25,
        slideBy: 4,
        mouseDrag: true,
        swipeAngle: false,
        container: container,
        speed: 400,
        edgePadding: 150,
        loop: false,
        responsive: {
          1200: {
            items: 4,
            edgePadding: 100,
            slideBy: 4,
          },
          850: {
            items: 3,
            edgePadding: 50,
            slideBy: 3,
          },
          768: {
            items: 3,
            edgePadding: 50,
            slideBy: 3,
          },
          500: {
            items: 2,
            edgePadding: 50,
            gutter: 15,
            slideBy: 2,
          },
          100: {
            items: 2,
            edgePadding: 30,
            gutter: 15,
            slideBy: 2,
          },
        },
      });

    this.sliders.push(slider);
    }

    disconnectedCallback() {
      this.abortController.abort();
    }
  })
}